<template>
  <div>
    <div class="main-wrapper">
      <!-- <layout-header2></layout-header2> -->
      <layout-header></layout-header>
      <breadcrumb3></breadcrumb3>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar></sidebar>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import patients from "../../../assets/json/doctor/mypatients.json";
const images = require.context("@/assets/img/patients", false, /\.png$|\.jpg$/);
import CommonApi from "../../../services/CommonApi";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    // this.get_practitioner_service_unit_hospital();
    if (this.$route.params.id) {
      console.log("this.$route.params.id", this.$route.params.id);
      this.get_exercise_Plan_details(this.$route.params.id);
      //sthis.get_schedule_details_vb(this.$route.params.id);
    }
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
  },
  components: {
    VueTimepicker,
  },
  data() {
    return {
      showspinner: true,
      disabled: true,
      patients: patients,
      service_unit_hospitals: [],
      name: this.$store.state.user.user_id,
      available_days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      activeday: "Sunday",
      schedule_data: {
        healthcare_practitioner: this.$store.state.user.user_id,
        hospital: "",
        slot_duration: "",
        fees: "",
      },
      Sunday: [],
      Monday: [],
      Tuesday: [],
      Wednesday: [],
      Thursday: [],
      Friday: [],
      Saturday: [],
    };
  },
  computed: {
    validation() {
      return (
        this.schedule_data.hospital &&
        this.schedule_data.slot_duration &&
        this.schedule_data.fees
      );
    },
  },
  watch: {
    validation() {
      if (
        this.schedule_data.slot_duration === "" ||
        this.schedule_data.hospital === "" ||
        this.schedule_data.hospital === null ||
        this.schedule_data.fees === ""
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
  },
  methods: {
    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    //Allow User to type number only
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    activeDay(day) {
      this.activeday = day;
    },

    /* Add Update practitioner_schedule */
    add_practitioner_schedule_vb() {
      if (!this.disabled) {
        this.$swal({
          text: "Adding Schedule",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        this.disabled = true;
        var data = new FormData();
        let slot = {};
        slot.Sunday = this.Sunday;
        slot.Monday = this.Monday;
        slot.Tuesday = this.Tuesday;
        slot.Wednesday = this.Wednesday;
        slot.Thursday = this.Thursday;
        slot.Friday = this.Friday;
        slot.Saturday = this.Saturday;
        data.append("data", JSON.stringify(this.schedule_data));
        data.append("time_slots", JSON.stringify(slot));
        CommonApi.post_data(
          "sahaj.appointment.add_practitioner_schedule_vb",
          data
        ).then((res) => {
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.$router.push(`/doctor/schedule-timings`);
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      }
    },

    /* Add Any Information */
    add_Information(type) {
      if (type === "Sunday") {
        this.Sunday.push({ from_time: "", to_time: "" });
      } else if (type === "Monday") {
        this.Monday.push({ from_time: "", to_time: "" });
      } else if (type === "Tuesday") {
        this.Tuesday.push({ from_time: "", to_time: "" });
      } else if (type === "Wednesday") {
        this.Wednesday.push({ from_time: "", to_time: "" });
      } else if (type === "Thursday") {
        this.Thursday.push({ from_time: "", to_time: "" });
      } else if (type === "Friday") {
        this.Friday.push({ from_time: "", to_time: "" });
      } else if (type === "Saturday") {
        this.Saturday.push({ from_time: "", to_time: "" });
      }
    },

    /* Remove Any Information */
    remove_item(type, id) {
      if (type === "Sunday") {
        this.Sunday.splice(id, 1);
      } else if (type === "Monday") {
        this.Monday.splice(id, 1);
      } else if (type === "Tuesday") {
        this.Tuesday.splice(id, 1);
      } else if (type === "Wednesday") {
        this.Wednesday.splice(id, 1);
      } else if (type === "Thursday") {
        this.Thursday.splice(id, 1);
      } else if (type === "Friday") {
        this.Friday.splice(id, 1);
      } else if (type === "Saturday") {
        this.Saturday.splice(id, 1);
      }
    },

    /* Get Service Unit Hospital */
    async get_practitioner_service_unit_hospital() {
      const params = new URLSearchParams();
      params.append("practitioner", this.name);
      await CommonApi.get_data(
        "sahaj.appointment.get_practitioner_service_unit_hospital",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.service_unit_hospitals = res.data;
        }
      });
    },

    async get_exercise_Plan_details(id) {
      const params = new URLSearchParams();
      params.append("name", id);
      await CommonApi.get_data(
        "sahaj.v1.physio.get_therapy_template_details",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          console.log("get_exercise_Plan_details", res.data);
        }
      });
    },

    /* Get Schedule Details */
    async get_schedule_details_vb(id) {
      const params = new URLSearchParams();
      params.append("name", id);
      await CommonApi.get_data(
        "sahaj.appointment.get_schedule_details_vb",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.schedule_data.healthcare_practitioner =
            res.data.healthcare_practitioner;
          this.schedule_data.hospital = res.data.hospital;
          this.schedule_data.slot_duration = res.data.slot_duration;
          this.schedule_data.fees = res.data.fees;

          if (res.data.schedule_slots.Sunday.length) {
            this.Sunday = [];
            res.data.schedule_slots.Sunday.map((item) =>
              this.Sunday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Monday.length) {
            this.Monday = [];
            res.data.schedule_slots.Monday.map((item) =>
              this.Monday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Tuesday.length) {
            this.Tuesday = [];
            res.data.schedule_slots.Tuesday.map((item) =>
              this.Tuesday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Wednesday.length) {
            this.Wednesday = [];
            res.data.schedule_slots.Wednesday.map((item) =>
              this.Wednesday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Thursday.length) {
            this.Thursday = [];
            res.data.schedule_slots.Thursday.map((item) =>
              this.Thursday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Friday.length) {
            this.Friday = [];
            res.data.schedule_slots.Friday.map((item) =>
              this.Friday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Saturday.length) {
            this.Saturday = [];
            res.data.schedule_slots.Saturday.map((item) =>
              this.Saturday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }
        }
      });
    },
  },
};
</script>
<style>
.time-slots .display-time {
  width: 150px !important;
}

.time-slots .clear-btn {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/NewExercisePlan.vue